(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kds-fashion-hero"] && !Shopify.designMode) return;
  try {
    
  class KdsFashionHero extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.cf = this.querySelector('[data-kfh-cf]');
      this.track = this.querySelector('[data-kfh-track]');
      this.cards = this.track ? Array.from(this.track.children) : [];
      this.prevBtn = this.querySelector('[data-kfh-prev]');
      this.nextBtn = this.querySelector('[data-kfh-next]');

      this.reveal();
      if (this.cards.length) this.initCoverflow();
    }

    reveal() {
      this.querySelectorAll('[data-kfh-stagger]').forEach((el, i) => {
        el.style.setProperty('--kfh-i', i);
      });
      const show = () => this.classList.add('kfh--revealed');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) { show(); return; }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { show(); io.disconnect(); } });
      }, { threshold: 0.12 });
      io.observe(this);
    }

    initCoverflow() {
      this.count = this.cards.length;
      this.active = Math.floor(this.count / 2);

      this.cards.forEach((card, i) => {
        card.addEventListener('click', (e) => {
          if (i !== this.active) { e.preventDefault(); this.go(i); }
        });
      });
      this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.active - 1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.active + 1));

      this.bindSwipe();
      this.layout();
      window.addEventListener('resize', () => this.layout(), { passive: true });
    }

    go(i) {
      const n = this.count;
      this.active = ((i % n) + n) % n;
      this.layout();
    }

    layout() {
      const n = this.count;
      const base = parseFloat(getComputedStyle(this).getPropertyValue('--kfh-card-w')) || 240;
      this.cards.forEach((card, i) => {
        let o = i - this.active;
        if (o > n / 2) o -= n;
        if (o < -n / 2) o += n;
        const ao = Math.abs(o);

        let x = o * base * 0.62;
        let y = ao * base * 0.11;
        let rot = o * 5;
        let scale = Math.max(0.6, 1 - ao * 0.14);
        const op = ao > 2 ? 0 : 1 - ao * 0.16;
        const z = 100 - ao;

        if (o === 0) { y = -base * 0.03; scale = 1.06; rot = 0; }

        card.style.setProperty('--x', x + 'px');
        card.style.setProperty('--y', y + 'px');
        card.style.setProperty('--rot', rot + 'deg');
        card.style.setProperty('--scale', scale);
        card.style.setProperty('--op', op);
        card.style.setProperty('--z', z);
        card.classList.toggle('is-active', o === 0);
        card.style.pointerEvents = op === 0 ? 'none' : 'auto';
        card.setAttribute('aria-hidden', op === 0 ? 'true' : 'false');
      });
    }

    bindSwipe() {
      let x0 = null;
      this.cf.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
      this.cf.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0;
        if (dx > 40) this.go(this.active - 1);
        else if (dx < -40) this.go(this.active + 1);
        x0 = null;
      });
      this.cf.addEventListener('pointercancel', () => { x0 = null; });
    }

    disconnectedCallback() {}
  }

  if (!customElements.get('kds-fashion-hero')) {
    customElements.define('kds-fashion-hero', KdsFashionHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
